export default __webpack_public_path__ + "static/media/markit-iq.3c6d449e.webp";